<div class="password-container">
  <input [type]="show ? 'text' : 'password'"
    class="form-control"
    [ngClass]="ngClass"
    [placeholder]="placeholder"
    [id]="id"
    [name]="name"
    [attr.maxlength]="maxlength"
    [attr.data-test-id]="dataTestId"
    [value]="value"
    [disabled]="isDisabled"
    (input)="handleInput($event)"
    (blur)="onTouched()"
    (keyup)="handleKeyup($event)" />


    <span [class]="className" (click)="toggle()" >
      @if (!show) {
        <app-svg-icon
          title="Show Password"
          [type]="'eye-slash'"
          [className]="'svg-icon'">
        </app-svg-icon>
      }

      @if (show) {
        <app-svg-icon
          title="Hide Password"
          [type]="'eye-open'"
          [className]="'svg-icon'">
        </app-svg-icon>
      }
    </span>
  </div>
